import React from 'react'
import styles from './ZoomButton.module.scss'

const ZoomButtonOutRedesign = (props) => (
  <button className={styles.zoomButtonOutRedesign} {...props}>
    <i aria-hidden="true" className="icon-CROSS_ICON" />
    <span className="sr-only">Close</span>
  </button>
)

export default ZoomButtonOutRedesign
